(function() {
  var createStorageKey, uploadAttachment;

  document.addEventListener("trix-attachment-add", function(event) {
    var attachment;
    attachment = event.attachment;
    if (attachment.file) {
      var $editor = $(event.target).first();
      var $form = $editor.closest('form');
      return uploadAttachment(attachment, $form);
    }
  });

  uploadAttachment = function(attachment, $form) {
    var $submit = $form.find('input[type="submit"]:first');
    if (!$submit.data('original_value')) {
      $submit.data('original_value', $submit.val());
    }
    
    $submit
      .attr('disabled', true)
      .val('Uploading...');

    var file, form, key, xhr;
    file = attachment.file;
    key = createStorageKey(file);
    form = new FormData;
    form.append("key", key);
    form.append("Content-Type", file.type);
    form.append("file", file);
    xhr = new XMLHttpRequest;
    xhr.open("POST", host, true);
    xhr.upload.onprogress = function(event) {
      var progress;
      progress = event.loaded / event.total * 100;
      return attachment.setUploadProgress(progress);
    };
    xhr.onload = function() {
      var href, url;

      // trix default code requires 204
      if (xhr.status === 200) {
        $submit
          .attr('disabled', false)
          .val($submit.data('original_value'));

          //Replaced original code - used xhr.responseUrl which IE cannot use
          //url = href = host + key;
          //url = href = xhr.responseURL;
          var jsonresponse = JSON.parse(xhr.response);
        url = href = jsonresponse.document;
        return attachment.setAttributes({
          url: url,
          href: href
        });
      }else{
          var jsonresponse = JSON.parse(xhr.response);
          alert(jsonresponse.message)
          location.reload();
      }
    };
    return xhr.send(form);
  };

  createStorageKey = function(file) {
    var date, day, time;
    date = new Date();
    day = date.toISOString().slice(0, 10);
    time = date.getTime();
    return "tmp/" + day + "/" + time + "-" + file.name;
  };

}).call(this);

/**
 * Wire file-picker UI onto Trix editors. Safe to call after lazy-loaded HTML
 * (e.g. participant Discussions tab) — skips editors already initialized.
 *
 * @param {Element|Document|jQuery|string} [root=document]
 */
window.initTrixDocumentUploads = function(root) {
    var $root = root ? $(root) : $(document);
    var $editors = $root.is('trix-editor') ? $root : $root.find('trix-editor');

    $editors.each(function () {
        var $editorEl = $(this);

        // Idempotent: skip editors that already have the file picker UI.
        if ($editorEl.data('trix-upload-initialized')) {
            return;
        }

        var editor = this.editor;
        var trix_id = $editorEl.attr('input');
        var trix_actual_id = $editorEl.attr('id');
        var that = $editorEl;

        if (!trix_id) {
            return;
        }

        $editorEl.data('trix-upload-initialized', true);

        //We want to save to local storage when people edit a trix editor, so they don't lose their progress
        $editorEl.on('trix-change', function() {
            // Save editor state to local storage
            if (editor) {
                localStorage.setItem(trix_actual_id, JSON.stringify(editor));
            }
        });

        //We also want to restore the trix editor states for this current page if in local storage
        if (editor && localStorage.getItem(trix_actual_id) !== undefined && localStorage.getItem(trix_actual_id) !== null) {
            editor.loadJSON(JSON.parse(localStorage.getItem(trix_actual_id)));
        }

        // Visually hide the input — display:none + programmatic click is blocked by browsers.
        var $input_file = $('<input type="file" name="file_'+trix_id+'" id="file_'+trix_id+'">').css({
            position: 'absolute',
            width: '1px',
            height: '1px',
            padding: 0,
            margin: '-1px',
            overflow: 'hidden',
            clip: 'rect(0, 0, 0, 0)',
            border: 0,
            opacity: 0
        });
        $editorEl.after($input_file);

        $input_file.on('change', function() {
            var element = $(this).get(0);
            if (!element.files[0]) {
                return $(this);
            }

            var file = element.files[0];
            var activeEditor = editor || $(that).get(0).editor;

            if (activeEditor) {
                activeEditor.insertFile(file);
            }

            // Allow selecting the same file again later.
            $(this).val('');
        });

        // Help text
        $editorEl.after('<span class="help-block"><i class="fa fa-paperclip"></i> Drag &amp; drop files into the box above or <u data-trix-editor-upload="'+trix_id+'">select files from your computer</u></span>');
    });
};

$(function() {
    //This relates to the trix local storage below. If a form is submitted on a page, clear out the trix local storage
    //for any trix editor on this page.
    $("form").each(function() {
        $(this).on("submit", function(){
            $('trix-editor').each(function () {
                var trix_actual_id = $(this).attr('id');
                localStorage.removeItem(trix_actual_id);
            });
        });
    });

    window.initTrixDocumentUploads(document);

    // Delegated so lazily inserted "select files" links work without re-binding.
    $(document).on('click', '[data-trix-editor-upload]', function (e) {
        e.preventDefault();
        var inputId = 'file_' + $(this).attr('data-trix-editor-upload');
        var input = document.getElementById(inputId);
        if (input) {
            // Native click inside a user gesture — required for the file picker.
            input.click();
        }
    }).on('mouseenter', '[data-trix-editor-upload]', function () {
        $(this).css({cursor: 'pointer'});
    });
});
